import * as React from "react";

;
export const Minus = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 11.25h20v1.5H2v-1.5z" fill="#100722" /></svg>;